"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSingleFilter = isSingleFilter;
exports.isGroupedColumnSet = isGroupedColumnSet;
exports.isAggregationStep = isAggregationStep;
exports.isFilterStep = isFilterStep;
exports.isSortStep = isSortStep;
exports.isRollingCalculationStep = isRollingCalculationStep;
exports.isLimitStep = isLimitStep;
exports.LimitPeriodType = exports.AggregationInterval = exports.QueryOperationType = exports.Conjunction = exports.Operator = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var Operator;
exports.Operator = Operator;

(function (Operator) {
  Operator["LESS_THAN"] = "<";
  Operator["LESS_THAN_OR_EQUAL"] = "<=";
  Operator["GREATER_THAN"] = ">";
  Operator["GREATER_THAN_OR_EQUAL"] = ">=";
  Operator["EQUALS"] = "=";
  Operator["BEFORE"] = "isBefore";
  Operator["EQUAL_OR_BEFORE"] = "isEqualOrBefore";
  Operator["AFTER"] = "isAfter";
  Operator["EQUAL_OR_AFTER"] = "isEqualOrAfter";
  Operator["NOT_EQUALS"] = "!=";
  Operator["EMPTY"] = "isEmpty";
  Operator["NOT_EMPTY"] = "isNotEmpty";
  Operator["CONTAINS"] = "contains";
  Operator["DOES_NOT_CONTAIN"] = "doesNotContain";
  Operator["IN"] = "in";
})(Operator || (exports.Operator = Operator = {}));

var Conjunction;
exports.Conjunction = Conjunction;

(function (Conjunction) {
  Conjunction["AND"] = "and";
  Conjunction["OR"] = "or";
})(Conjunction || (exports.Conjunction = Conjunction = {}));

function isSingleFilter(f) {
  return !!f.columnName && !!f.operator;
}

function isGroupedColumnSet(groupedColumn) {
  return _typeof(groupedColumn) === 'object' && !!(groupedColumn !== null && groupedColumn !== void 0 && groupedColumn.parentColumn);
}

var QueryOperationType;
exports.QueryOperationType = QueryOperationType;

(function (QueryOperationType) {
  QueryOperationType["AGGREGATION"] = "aggregation";
  QueryOperationType["ROLLING_CALCULATION"] = "rollingCalculation";
  QueryOperationType["FILTER"] = "filter";
  QueryOperationType["SORT"] = "sort";
  QueryOperationType["LIMIT"] = "limit";
})(QueryOperationType || (exports.QueryOperationType = QueryOperationType = {}));

function isAggregationStep(queryStep) {
  return queryStep.operationType === QueryOperationType.AGGREGATION;
}

function isFilterStep(queryStep) {
  return queryStep.operationType === QueryOperationType.FILTER;
}

function isSortStep(queryStep) {
  return queryStep.operationType === QueryOperationType.SORT;
}

function isRollingCalculationStep(queryStep) {
  return queryStep.operationType === QueryOperationType.ROLLING_CALCULATION;
}

function isLimitStep(queryStep) {
  return queryStep.operationType === QueryOperationType.LIMIT;
}

var AggregationInterval;
exports.AggregationInterval = AggregationInterval;

(function (AggregationInterval) {
  AggregationInterval["YEAR"] = "year";
  AggregationInterval["QUARTER"] = "quarter";
  AggregationInterval["MONTH"] = "month";
  AggregationInterval["DAY"] = "day";
  AggregationInterval["SEMI_ANNUAL"] = "semi_annual";
  AggregationInterval["WEEK"] = "week";
})(AggregationInterval || (exports.AggregationInterval = AggregationInterval = {}));

var LimitPeriodType;
exports.LimitPeriodType = LimitPeriodType;

(function (LimitPeriodType) {
  LimitPeriodType["INSTANTANEOUS"] = "instantaneous";
  LimitPeriodType["PERIODIC"] = "periodic";
})(LimitPeriodType || (exports.LimitPeriodType = LimitPeriodType = {}));